/* tslint:disable */
/* eslint-disable */

/**
 * Upgrade product
 */
export enum UpgradeProduct {
  EconomyToBusiness = 'ECONOMY-TO-BUSINESS',
  EconomyToPremiumeconomy = 'ECONOMY-TO-PREMIUMECONOMY',
  PremiumeconomyToBusiness = 'PREMIUMECONOMY-TO-BUSINESS'
}
